import {Environment} from './environment';
import {Locale} from './locale';
import {development} from './urlMappings/development';
import {preview} from './urlMappings/preview';
import {production} from './urlMappings/production';
import {staging} from './urlMappings/staging';
import {UrlConfig} from './urlMappings/types';

export const allConfigs = [production, preview, staging, development].reduce<
  Array<UrlConfig<Locale, Environment>>
>((acc, env) => acc.concat(Object.values({...env})), []);
